import styled from "styled-components";
import { IInputContentStyled } from "./Input.types";

export const InputContentStyled = styled("div")<IInputContentStyled>`
  input {
    border-radius: 8px;
    border: 1px solid ${(props) => (props.isError ? "red" : "#b5b5b5")};
    width: 100%;
    color: #333;
    padding: 10px;
    outline: none;
    font-size: 14px;
    transition: all 0.3s ease;

    &:hover {
      background-color: #f5f5f5;
    }
  }
`;
